/* =========================================================
DEKOFAR PRODUCT SYSTEM V2
PAINT CALCULATOR

Yalnızca paint ürün ailesinde kullanılır.

Görev:
- Boyanacak alan değerini okur
- Metafield'dan gelen coverage değerini kullanır
- Metafield'dan gelen kat sayısını kullanır
- İhtiyaç miktarını dinamik olarak hesaplar

HESAPLAMA MANTIĞI:

coverage_per_unit = TEK KAT kaplama alanıdır.

Örnek:
1 Kg = 11 m² tek kat kaplama

Kat sayısı = 1
11 m² alan için = 1 Kg

Kat sayısı = 2
11 m² alan için = 2 Kg

Formül:
Alan × Kat Sayısı ÷ Tek Kat Kaplama
========================================================= */

function dekofarV2InitPaintCalculators(scope) {
  const root = scope || document;

  root
    .querySelectorAll(
      '[data-dekofar-v2-paint-calculator]'
    )
    .forEach((calculator) => {

      /* =====================================================
         DAHA ÖNCE BAŞLATILDI MI?
      ===================================================== */

      if (
        calculator.dataset
          .dekofarV2PaintCalculatorInitialized ===
        'true'
      ) {
        return;
      }


      /* =====================================================
         COVERAGE
         TEK KAT KAPLAMA DEĞERİ
      ===================================================== */

      const rawCoverage =
        calculator.getAttribute(
          'data-coverage-per-unit'
        );


      const coveragePerUnit =
        parseFloat(
          String(
            rawCoverage || ''
          ).replace(
            ',',
            '.'
          )
        );


      /* =====================================================
         COVERAGE BİRİMİ
      ===================================================== */

      const coverageUnit =
        calculator.getAttribute(
          'data-coverage-unit'
        ) || '';


      /* =====================================================
         KAT SAYISI

         Liquid tarafından:

         data-coat-count="1"
         data-coat-count="2"
         data-coat-count="3"

         şeklinde gelir.

         Veri yoksa varsayılan = 1
      ===================================================== */

      const rawCoatCount =
        calculator.getAttribute(
          'data-coat-count'
        );


      let coatCount =
        parseInt(
          String(
            rawCoatCount || '1'
          ),
          10
        );


      if (
        !Number.isFinite(
          coatCount
        ) ||
        coatCount < 1
      ) {
        coatCount = 1;
      }


      /* =====================================================
         ELEMENTLER
      ===================================================== */

      const areaInput =
        calculator.querySelector(
          '[data-dekofar-v2-paint-area]'
        );


      const result =
        calculator.querySelector(
          '[data-dekofar-v2-paint-result]'
        );


      const resultValue =
        calculator.querySelector(
          '[data-dekofar-v2-paint-result-value]'
        );


      const resultUnit =
        calculator.querySelector(
          '[data-dekofar-v2-paint-result-unit]'
        );


      /* =====================================================
         GEREKLİ VERİ KONTROLÜ
      ===================================================== */

      if (
        !areaInput ||
        !result ||
        !resultValue ||
        !Number.isFinite(
          coveragePerUnit
        ) ||
        coveragePerUnit <= 0
      ) {
        return;
      }


      calculator.dataset
        .dekofarV2PaintCalculatorInitialized =
        'true';


      /* =====================================================
         SONUÇ FORMATLAMA
      ===================================================== */

      const formatResult =
        (value) => {

          if (
            !Number.isFinite(
              value
            )
          ) {
            return '0';
          }


          if (
            Math.abs(
              value -
              Math.round(
                value
              )
            ) < 0.001
          ) {

            return String(
              Math.round(
                value
              )
            );
          }


          return value
            .toFixed(2)
            .replace(
              /0+$/,
              ''
            )
            .replace(
              /\.$/,
              ''
            )
            .replace(
              '.',
              ','
            );
        };


      /* =====================================================
         HESAPLAMA

         Formül:

         ihtiyaç =
         alan × kat sayısı
         ----------------
         tek kat kaplama
      ===================================================== */

      const updateCalculator =
        () => {

          const area =
            parseFloat(
              String(
                areaInput.value || ''
              ).replace(
                ',',
                '.'
              )
            );


          /* -------------------------------------------------
             GEÇERSİZ / BOŞ ALAN
          ------------------------------------------------- */

          if (
            !Number.isFinite(
              area
            ) ||
            area <= 0
          ) {

            result.hidden =
              true;

            resultValue
              .textContent =
              '0';

            return;
          }


          /* -------------------------------------------------
             GEREKLİ BOYA MİKTARI
          ------------------------------------------------- */

          const requiredAmount =
            (
              area *
              coatCount
            ) /
            coveragePerUnit;


          /* -------------------------------------------------
             SONUCU YAZ
          ------------------------------------------------- */

          resultValue
            .textContent =
            formatResult(
              requiredAmount
            );


          /* -------------------------------------------------
             KG / L BİRİMİ
          ------------------------------------------------- */

          if (
            resultUnit
          ) {

            resultUnit
              .textContent =
              coverageUnit
                .toUpperCase();
          }


          result.hidden =
            false;
        };


      /* =====================================================
         INPUT EVENTS
      ===================================================== */

      areaInput.addEventListener(
        'input',
        updateCalculator
      );


      areaInput.addEventListener(
        'change',
        updateCalculator
      );


      /* =====================================================
         SAYFA AÇILDIĞINDA INPUT DOLUYSA HESAPLA
      ===================================================== */

      if (
        areaInput.value
      ) {
        updateCalculator();
      }

    });
}